import React from 'react';
import { Link } from 'gatsby';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import { Typography } from '../../atoms/typography/Typography';
import { Stack } from '../../atoms/stack/Stack';
import Header from '../../organisms/shared/header/Header';
import Footer from '../../organisms/shared/footer/Footer';

export const NotFound = ({
  hero,
  menu,
  footer,
  siteUrls,
  location,
  locale,
  search,
  t,
}) => (
  <Stack className="bg-white overflow-x-hidden min-h-[100vh] justify-between">
    <NavigationBar
      data={menu}
      location={location}
      locale={locale}
      search={search}
      t={t}
    />
    <Header minimized />
    <main>
      <Stack className="justify-center items-center gap-5 py-20 px-8">
        <Typography as="h1" fontVariant="h3" className="leading-none">
          {hero.title}
        </Typography>
        <Typography fontVariant="h6" className="font-medium leading-none">
          {hero.description}
        </Typography>
        <Link
          to={hero.homeLinkUrl}
          className="text-primary-500 underline global-hover"
        >
          {hero.homeLinkText}
        </Link>
      </Stack>
    </main>
    <Footer data={footer} siteUrls={siteUrls} />
  </Stack>
);

NotFound.propTypes = {};
